import React from 'react';
import Link from '../Link';
import colors from '../../styles/themes/variables.module.scss';
import styles from './styles.module.scss';

const tematicas = [
  { nombre: "Bajo el mar", color: colors.pink, link: "/productos/tematica/bajo-el-mar" },
  { nombre: "Circo", color: colors.yellow, link: "/productos/tematica/circo" },
  { nombre: "Dinosaurios", color: colors.green, link: "/productos/tematica/dinosaurios" },
  { nombre: "Gatitos", color: colors.purple, link: "/productos/tematica/gatitos" },
  { nombre: "Sirena", color: colors.blue, link: "/productos/tematica/sirena" },
];

const ContenedorTematicas = () => {

  return (<>
    <div className={styles.contenedor}>
      {tematicas.map((item) => (
        <Link key={item.link} className={styles.circuloCategoria} href={item.link}>
          <h2 className={styles.nombre}>{item.nombre}</h2>
          <div className={styles.circulo} style={{ backgroundColor: item.color }} />
          <img
            src="/img/shadow.png"
            alt={`Temática ${item.nombre}`}
          />
        </Link>
      ))}
      <Link className={styles.circuloCategoria} href="/tematicas">
        <h2 className={styles.nombre}>Ver todas las temáticas</h2>
        <div className={styles.circulo} style={{ backgroundColor: colors.pink2 }} />
        <img
          src="/img/shadow.png"
          alt="Ver todas las temáticas de We Celebrate!"
        />
      </Link>
    </div>
  </>);
};

export default ContenedorTematicas;
